import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import client from "../lib/api/client";
import {store} from "react-notifications-component";
import {withRouter} from "react-router-dom";
import TitleHead from "../assets/title_head.svg";

// Require Editor JS files.
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/js/plugins.pkgd.min.js';

// Require Editor CSS files.
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import FroalaEditor from 'react-froala-wysiwyg';
import {useDispatch, useSelector} from "react-redux";
import {addBoardFileList, clearBoardFileList, deleteBoardFileList} from "../modules/file";
import {useRecoilValue} from "recoil";
import {userState} from "../state/globalState";
import {deleteBlobFile, fileUploadToAzureStorage} from "../lib/api/file";
import QuestionDropzone from "../components/board/QuestionDropzone";
import LoadingPop from "../components/common/LoadingPop";

const useStyles = makeStyles(theme => ({
    root: {
        height: "100%",
        width: "100%",
        margin: "30px 0"
    },
    wtireButton: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-end",
        marginTop: "10px",
        gap: "10px"
    },
    boardWrapper: {
        marginTop: "20px"
    }
}));

const WriteForm = ({ brdNo, setViewState, reTitle, history }) => {
    const userInfo = useRecoilValue(userState);
    const [config, setConfig] = useState(null);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [disable, setDisable] = useState(false);
    let {user} = useSelector(({user}) => ({user}));
    const classes = useStyles();
    const dispatch = useDispatch();

    const froalaConfig = {
        key: 'pe1G2wF1I1B2D3C7D6B5oqlB1twtfA4A3G3E3F2B6C4C4E3A2==',
        fullPage: true,
        useClasses: false,
        charCounterCount: false,
        minHeight: 600,
        // height: 'calc(100vh - 300px)',
        height: 800,
        maxHeight: 900,
        zIndex: 0,
        colorsHEXInput: false,
        autoFocus: true,
        linkAlwaysBlank: true,
        listAdvancedTypes: true,
        attribution: false,
        fontFamilySelection: true,
        fontSizeSelection: true,
        paragraphFormatSelection: true,
        placeholderText: "",
        imageAllowedTypes: ["jpeg", "jpg", "png", "gif", "webp"],
        imageDefaultAlign: "left",
        imageMaxSize: 1021 * 1024 * 5,
        imageUpload: true,
        fileUpload: false,
        imageMove: true,
        // fileMaxSize: 1024 * 1024 * 100,
        // filesManagerAllowedTypes: ["*"],
        // filesManagerMaxSize: 1024 * 1024 * 100,
        // fileAllowedTypes: ["*"],
        fileUseSelectedText: true,
        quickInsertButtons: ["embedly", "table", "ul", "ol", "hr"],
        toolbarButtons: {
            moreText: {
                buttons: ["bold", "italic", "underline", "strikeghrough", "subscript", "superscript", "fontFamily", "fontSize", "textColor", "backgroundColor", "inlineClass", "inlineStyle", "clearFormatting"]
            },
            moreParagraph: {
                buttons: ["alignLeft", "alignCenter", "formatOLSimple", "alignRight", "alignJustify", "formatOL", "formatUL", "paragraphFormat", "paragraphStyle", "lineHeight", "outdent", "indent", "quote"]
            },
            moreRich: {
                buttons: ["insertLink", "insertImage", "insertTable", "emoticons", "fontAwesome", "specialCharacters", "embedly", "insertHR"]
            },
            moreMisc: {
                buttons: ["undo", "redo", "print", "getPDF", "spellChecker", "selectAll", "html", "help"],
                align: "right",
                buttonsVisible: 2
            },
        },
        events: {
            // @ts-ignore
            initialized() {
                const editor = this;
                editor.events.on("drop", (dropEvent) => {
                    dropEvent.preventDefault();
                    // 이미지 드랍 첨부 방지
                    if (dropEvent.originalEvent.dataTransfer.files.length) {
                        return false;
                    }
                }, true);
            },
                // eslint-disable-next-line func-names
            "image.beforeUpload": async function (images) {
                const instEditor = this;
                if (images.length) {
                    const readImageAsBase64 = (file) => {
                        return new Promise((resolve, reject) => {
                            const reader = new FileReader();

                            reader.onload = () => {
                                resolve(reader.result);
                            };

                            reader.onerror = () => {
                                reject(reader);
                            };

                            reader.readAsDataURL(file);
                        });
                    };

                    const readers = [];

                    for (let i = 0; i < images.length; i += 1) {
                        readers.push(readImageAsBase64(images[i]));
                    }

                    Promise.all(readers).then((values) => {
                        values.forEach((enc) => {
                            // @ts-ignore
                            instEditor.image.insert(enc, true, { name: "froala_image" }, null, null);
                        });
                    });
                }
                return false;
            },
            // eslint-disable-next-line func-names
            "image.inserted": async function () {
                const instEditor = this;
                const iframe = document.getElementsByClassName("fr-iframe")[0];
                // @ts-ignore
                const elemList = iframe.contentWindow.document.querySelectorAll("img:not([name='froala_image'])");
                // eslint-disable-next-line no-restricted-syntax
                for (const elem of elemList) {
                    elem.remove();
                    // @ts-ignore
                    if (instEditor.undo.canDo()) instEditor.undo.saveStep();
                }
                // @ts-ignore
                instEditor.popups.hideAll();
            },
        }
    };


    useEffect(() => {
        setConfig({
            key: 'pe1G2wF1I1B2D3C7D6B5oqlB1twtfA4A3G3E3F2B6C4C4E3A2==',
            charCounterCount: false,
            placeholderText: "",
            minHeight: 600,
            // height: 'calc(100vh - 300px)',
            height: 800,
            maxHeight: 900,
            colorsHEXInput: false,
            autoFocus: true,
            linkAlwaysBlank: true,
            fontFamilySelection: true,
            fontSizeSelection: true,
            paragraphFormatSelection: true,
            tabSpaces: 4,
            quickInsertButtons: ['table', 'ol', 'ul'],
            pluginsEnabled: ['align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'embedly', 'emoticons', 'entities', 'file', 'fontFamily', 'fontSize', 'lineHeight', 'fullscreen', 'image', 'imageManager', 'inlineStyle', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quickInsert', 'quote', 'save', 'table', 'url', 'video', 'wordPaste'],
            toolbarButtons:{
                moreText: {
                    buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting'],

                    // Alignment of the group in the toolbar.
                    align: 'left',

                    // By default, 3 buttons are shown in the main toolbar. The rest of them are available when using the more button.
                    buttonsVisible: 4
                },

                moreParagraph: {
                    buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
                    align: 'left',
                    buttonsVisible: 4
                },

                moreRich: {
                    buttons: ['insertLink', 'insertImage', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertHR'],
                    align: 'left',
                    buttonsVisible: 4
                },

                moreMisc: {
                    buttons: ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
                    align: 'right',
                    buttonsVisible: 2
                }
            },
            htmlAllowedTags: [".*"],
            htmlRemoveTags: ["script"],
            htmlUntouched: true,
            imageUpload: true,
            imageMove: true,
            imageDefaultAlign: 'left',
            imageDefaultDisplay: 'inline-block',
            imageMaxSize: 5 * 1024 * 1024,
            imageAllowedTypes: ['jpeg', 'jpg', 'png'],
            events: {
                initialized() {
                    const editor = this;
                    editor.events.on("drop", (dropEvent) => {
                        dropEvent.preventDefault();
                        // 이미지 드랍 첨부 방지
                        if (dropEvent.originalEvent.dataTransfer.files.length) {
                            return false;
                        }
                    }, true);
                },
                'image.beforeUpload': async function (images) {
                    const instEditor = this;
                    const opts = {
                        stdYear: userInfo.stdYear,
                        admnNo: brdNo,
                        attcFileBizGcd: "hc056003",
                    }
                    console.log(images);

                    if (images.length) {
                        const readImageAsBase64 = (file) => {
                            return new Promise((resolve, reject) => {
                                const reader = new FileReader();

                                reader.onload = () => {
                                    resolve(reader.result);
                                };

                                reader.onerror = () => {
                                    reject(reader);
                                };

                                reader.readAsDataURL(file);
                            });
                        };

                        const readers = [];

                        for (let i = 0; i < images.length; i += 1) {
                            readers.push(readImageAsBase64(images[i]));
                        }

                        Promise.all(readers).then((values) => {
                            values.forEach((enc) => {
                                // @ts-ignore
                                instEditor.image.insert(enc, true, { name: "froala_image" }, null, null);
                            });
                        });
                    }
                    return false;

                    //  const { data } = await fileUploadToAzureStorage(images[0], opts);
                    // const { blobUrl } = data.payload;
                    // const urlArray = blobUrl.split("/");
                    //
                    // const containerName = urlArray[urlArray.length - 2];
                    // const fileName = urlArray[urlArray.length - 1];
                    //
                    // const link = `${process.env.REACT_APP_API_URL}/storage/link?containerName=${containerName}&blobName=${fileName}`;
                    // console.log("Link :", link);
                    // instEditor.image.insert(`${process.env.REACT_APP_API_URL}/storage/link?containerName=${containerName}&blobName=${fileName}`, null, null, instEditor.image.get());
                },
                // 'image.beforeRemove': function (img) {
                //     const src = img[0].src;
                //     handleRemoveFile(src);
                // },
                'image.loaded': function (img) {
                    // console.log(img);
                },
                // 'file.beforeUpload': async function (files) {
                //     const instEditor = this;
                //     console.log(instEditor);
                //     instEditor.file.insert("test", files[0].name);
                //     return true;
                //     // const opts = {
                //     //     stdYear: userInfo.stdYear,
                //     //     admnNo: brdNo,
                //     //     attcFileBizGcd: "hc056003",
                //     // }
                //     // const { data } = await fileUploadToAzureStorage(files[0], opts);
                //     // instEditor.file.insert(data.payload.blobUrl, files[0].name);
                // },
                // 'file.unlink': function (link) {
                //     const removeFile = files.find((item) => item === link.textContent.normalize("NFC"));
                //     if (removeFile) {
                //         client.post("/api/removefile", {
                //             fileNo: removeFile.length > 0 ? removeFile[0].BRD_FILE_NO : "",
                //             fileName: link.textContent.normalize("NFC")
                //         }).then(res => {
                //             console.log(res);
                //         }).catch(err => {
                //             console.log(err);
                //         });
                //     }
                // },
                // eslint-disable-next-line func-names
                "image.inserted": async function () {
                    const instEditor = this;
                    const iframe = document.getElementsByClassName("fr-iframe")[0];
                    // @ts-ignore
                    if(iframe){
                        const elemList = iframe.contentWindow.document.querySelectorAll("img:not([name='froala_image'])");
                        // eslint-disable-next-line no-restricted-syntax
                        if (elemList) {
                            for (const elem of elemList) {
                                elem.remove();
                                // @ts-ignore
                                if (instEditor.undo.canDo()) instEditor.undo.saveStep();
                            }
                        }
                    }
                    // @ts-ignore
                    instEditor.popups.hideAll();
                },
            }
        });

        if (brdNo) {
            client.get(`/kognr/board/${brdNo}`, {cache: false}).then(response => {
                const { board } = response.data.payload;
                const { content, title } = board;
                setTitle(title);
                setContent(content);
                // if (response.data.files) {
                //     setFiles(response.data.files);
                //     localStorage.setItem("BRD_FILE", JSON.stringify(response.data.files));
                // }
            }).catch((error) => {
                console.log(error);
            });
        }

        if (reTitle !== "") {
            setTitle(reTitle);
        }

        // dispatch(clearBoardFileList());

    }, []);

    const handleTitleChange = (e) => {
        if (e.target.value.length < 200) {
            setTitle(e.target.value);
        }
    };

    const handleModelChange = (model) => {
        setContent(model);
    };

    const handleCancelClick = () => {
        setViewState("LIST");
        history.push("/questions");
    }

    const handleSaveButtonClick = () => {
        // content에서 tmp 폴더 삭제
        // const replaced = content.replace(/\/tmp\//gi, "/");
        // const data = encodeURIComponent(replaced);
        // const encode = window.btoa(data);

        if (title === "") {
            store.addNotification({
                title: "알림",
                message: "제목을 입력하세요.",
                type: 'warning',
                insert: "top",
                container: "top-center",
                animationIn: ["animated", "flipInY"],
                animationOut: ["animated", "flipOutY"],
                dismiss: {
                    duration: 3000,
                    onScreen: false
                },
                width: 500
            });
            return;
        }

        if (content === "") {
            store.addNotification({
                title: "알림",
                message: "내용을 입력하세요.",
                type: 'warning',
                insert: "top",
                container: "top-center",
                animationIn: ["animated", "flipInY"],
                animationOut: ["animated", "flipOutY"],
                dismiss: {
                    duration: 3000,
                    onScreen: false
                },
                width: 500
            });
            return;
        }

        if (brdNo) {
            setDisable(true);
            client.post(`/kognr/board/${brdNo}`, {
                title,
                content
            }).then(response => {
                const { payload, success } = response.data;
                setDisable(false);
                if (success) {
                    setViewState("LIST");
                    history.push("/questions");

                }

            }).catch((error) => {
                console.log(error);
            });
        } else {
            setDisable(true);
            client.post('/kognr/board', {
                stdYear: userInfo.stdYear,
                admnNo: userInfo.admnNo,
                title,
                content,
                corprInfoDiviNo: userInfo.corprInfoDiviNo,
                userNm: userInfo.userNm
            }).then(response => {
                // if (response.saveSuccess) {
                //     store.addNotification({
                //         title: "알림",
                //         message: response.message,
                //         type: 'success',
                //         insert: "top",
                //         container: "top-center",
                //         animationIn: ["animated", "flipInY"],
                //         animationOut: ["animated", "flipOutY"],
                //         dismiss: {
                //             duration: 3000,
                //             onScreen: false
                //         },
                //         width: 500
                //     });
                //     dispatch(clearBoardFileList());
                // } else {
                //     store.addNotification({
                //         title: "알림",
                //         message: response.message,
                //         type: 'danger',
                //         insert: "top",
                //         container: "top-center",
                //         animationIn: ["animated", "flipInY"],
                //         animationOut: ["animated", "flipOutY"],
                //         dismiss: {
                //             duration: 3000,
                //             onScreen: false
                //         },
                //         width: 500
                //     });
                // }
                console.log(response);
                setDisable(false);
                setViewState("LIST");
                history.push("/questions");

            }).catch((error) => {
                console.log(error);
            });
        }
    }

    const handleRemoveFile = (fileName) => {
        console.log(decodeURI(fileName));
        const decodeFileName = decodeURI(fileName);
        // const removeFile = localFileInfo?.find((item) => {
        //     return item.BRD_FILE_NM.normalize("NFC") === decodeFileName.substring(decodeFileName.lastIndexOf("/") + 1);
        // });
        //
        // deleteBlobFile(fileUuid, bizFileSeq, fileSeq, "hc056003").then((res) => {
        //     const { data } = res;
        //     if (data.success) {
        //         getFiles(brdNo, userInfo.stdYear);
        //     }
        // });

        // client.post("/api/removefile", {
        //     fileNo: removeFile && removeFile.BRD_FILE_NO,
        //     fileName: decodeFileName.substring(decodeFileName.lastIndexOf("/") + 1)
        // }).then(res => {
        //     if (res.data.removeFileSuccess) {
        //         console.log("파일 삭제 성공");
        //     }
        // }).catch(err => {
        //     console.log(err);
        // });
    }

    return (
        config &&
            <Grid container
                  direction="column"
                  alignItems="flex-start"
                  justifyContent="center"
            >
                <div className={classes.root}>
                    <div className="title-head">
                        <img src={TitleHead}/>
                        <span>1:1 문의 글쓰기</span>
                    </div>
                    <div className={classes.boardWrapper}>
                        <TextField
                            required
                            fullWidth
                            label="제목"
                            variant="standard"
                            value={title}
                            onChange={handleTitleChange}
                        />
                    </div>
                    <div className={classes.boardWrapper}>
                        <FroalaEditor
                            tag='textarea'
                            config={froalaConfig}
                            model={content}
                            onModelChange={handleModelChange}
                        />
                    </div>
                    {brdNo && <QuestionDropzone brdNo={brdNo} />}
                    {!brdNo && <QuestionDropzone brdNo={userInfo.admnNo} />}
                    <div className={classes.wtireButton}>
                        <Button variant="outlined" size="small" color="primary" onClick={handleCancelClick}>
                            취소
                        </Button>
                        <Button variant="contained" size="small" color="primary" disabled={disable} onClick={handleSaveButtonClick}>
                            저장
                        </Button>
                    </div>
                    {disable && <LoadingPop/>}
                </div>
            </Grid>
    );
};

export default withRouter(WriteForm);
